import { broadcastQueryClient } from "@tanstack/query-broadcast-client-experimental";
import { queryClient } from "./queryClient";

/**
 * Live-sync the query cache across same-origin windows over a BroadcastChannel:
 * an invalidation/update in one window (e.g. a scheme created and its list
 * invalidated) reaches the others without a reload. localStorage persistence is
 * only a boot-time snapshot — this is the live channel on top of it.
 *
 * Same origin => same Cognito session => same user, so this never crosses users.
 * Call once at app startup.
 */
export function setupQueryBroadcast(): void {
  broadcastQueryClient({ queryClient, broadcastChannel: "mp-query-sync" });
}
